<button mat-flat-button color="primary" class="make-offer-btn !mx-3" [matMenuTriggerFor]="menu" data-cy="make-offer-btn">
	Make Offer
</button>

<!-- (click)="openNewOfferDialog()" -->

<mat-menu #menu="matMenu">
	<button (click)="openNewOfferDialog()" mat-menu-item data-cy="new-offer-btn">New Offer</button>
	<button (click)="openNewOfferDialog(true)" mat-menu-item data-cy="offer-link-btn">Offer Link</button>
</mat-menu>